/** 跨页面共用的业务标签（lib/copy.ts）：生成方式、素材角色、Key 权限、流水类型、任务步骤、失败建议、错误码说明。 */
const messages = {
  'mode.text_to_video': '文生视频',
  'mode.first_frame': '首帧生成',
  'mode.first_last_frame': '首尾帧生成',
  'mode.reference': '多模态参考',

  'role.first_frame': '首帧',
  'role.last_frame': '尾帧',
  'role.reference_image': '参考图片',
  'role.reference_video': '参考视频',
  'role.reference_audio': '参考音频',

  'scope.tasks:create.title': '创建任务',
  'scope.tasks:create.description': '提交视频生成任务，会冻结并结算额度',
  'scope.tasks:read.title': '查询任务',
  'scope.tasks:read.description': '查询本账号的任务状态与结果',
  'scope.assets:read.title': '读取素材',
  'scope.assets:read.description': '列出和查看素材',
  'scope.assets:write.title': '管理素材',
  'scope.assets:write.description': '上传、导入、重命名和删除素材',

  'ledger.grant': '发放',
  'ledger.deduct': '扣减',
  'ledger.reversal': '冲正',
  'ledger.reserve': '冻结',
  'ledger.release': '释放',
  'ledger.settle': '结算',
  'ledger.waive': '免单',
  'ledger.commission': '推荐佣金',
  'ledger.refund': '退款',
  'ledger.topup': '充值',
  'ledger.topup_bonus': '充值赠送',
  'ledger.redeem': '兑换码',

  'ledgerHint.grant': '运营确认线下付款后发放的额度',
  'ledgerHint.deduct': '运营按约定扣减的额度',
  'ledgerHint.reversal': '对一笔发放或扣减的更正',
  'ledgerHint.reserve': '任务受理时按上界冻结，结束后结算并释放差额',
  'ledgerHint.release': '任务结束后退回未使用的冻结额度',
  'ledgerHint.settle': '按实际用量结算的金额',
  'ledgerHint.waive': '平台原因导致失败，费用全部免除',
  'ledgerHint.commission': '推荐返佣结算后计入的额度',
  'ledgerHint.refund': '运营核实后退回的任务费用',
  'ledgerHint.topup': '数字货币充值到账',
  'ledgerHint.topup_bonus': '充值活动赠送的额度',
  'ledgerHint.redeem': '用兑换码兑换的额度',

  'step.queued': '排队',
  'step.preparing': '准备素材',
  'step.running': '生成中',
  'step.recovering': '恢复处理中',
  'step.reconciling': '核查结果',
  'step.finalizing': '保存结果',
  'step.succeeded': '完成',
  'step.failed': '失败',

  'assetKind.image': '图片',
  'assetKind.video': '视频',
  'assetKind.audio': '音频',

  'trust.normal': '普通素材',
  'trust.virtual_avatar': '虚拟人像',
  'trust.real_person': '真人人像',

  'failure.no_available_channel': '本站暂时没有可用的处理线路。请稍后用新的幂等键重新提交。',
  'failure.upstream_status_unknown': '平台未能确认生成结果。请查看下方费用明细，并用新的幂等键重新提交。',
  'failure.task_deadline_exceeded': '任务超过处理时限仍未完成。可降低时长或分辨率后重新提交。',
  'failure.content_rejected':
    '提示词或生成内容未通过内容审核。请调整描述后重新提交，重复提交同样内容仍会失败。',
  'failure.asset_rejected': '输入素材未通过审核或格式校验。请更换素材后重试。',
  'failure.invalid_parameter': '参数组合不受支持。请对照模型能力表检查分辨率、比例、时长与输入数量。',
  'failure.account_suspended': '账号已被停用，请联系运营。',
  'failure.result_unavailable': '生成结果无法取回。请重新提交。',
  'failure.internal_error': '平台内部错误。请稍后重试；如反复出现，请带上请求 ID 联系运营。',

  'errorDoc.invalid_request.scene': 'JSON 格式错误、Content-Type 不是 application/json，或缺少 / 超长的 Idempotency-Key；请求体超过 1 MB 时为 413',
  'errorDoc.invalid_request.action': '修正请求后重发',
  'errorDoc.invalid_api_key.scene': 'Key 不存在、已撤销、已过期或已停用',
  'errorDoc.invalid_api_key.action': '在控制台检查 Key 状态',
  'errorDoc.unauthenticated.scene': '控制台会话未登录或已过期',
  'errorDoc.unauthenticated.action': '重新登录',
  'errorDoc.quota_exceeded.scene': '账号可用额度不足；冻结上界超过 max_budget；素材存储空间已满',
  'errorDoc.quota_exceeded.action': '补充额度、调整 max_budget 或清理素材后重试',
  'errorDoc.key_limit_exceeded.scene': 'Key 累计或日限额不足',
  'errorDoc.key_limit_exceeded.action': '调整 Key 限额后重试',
  'errorDoc.permission_denied.scene': 'Key 缺少 scope、模型不在 Key 白名单，或账号未开通该模型',
  'errorDoc.permission_denied.action': '在控制台为 Key 增加权限，或联系运营开通模型',
  'errorDoc.csrf_failed.scene': '控制台请求缺少或携带了失效的 CSRF 令牌',
  'errorDoc.csrf_failed.action': '刷新页面后重试',
  'errorDoc.account_suspended.scene': '账号已被停用',
  'errorDoc.account_suspended.action': '联系运营',
  'errorDoc.not_found.scene': '资源不存在，或不属于你',
  'errorDoc.not_found.action': '检查 ID 是否正确',
  'errorDoc.idempotency_conflict.scene': '同一幂等键，但请求体不同',
  'errorDoc.idempotency_conflict.action': '为新请求使用新的幂等键',
  'errorDoc.conflict.scene': '资源状态冲突',
  'errorDoc.conflict.action': '重新查询最新状态后再操作',
  'errorDoc.asset_in_use.scene': '素材仍被进行中的任务引用',
  'errorDoc.asset_in_use.action': '待任务结束后再删除',
  'errorDoc.group_not_empty.scene': '分组内仍有素材',
  'errorDoc.group_not_empty.action': '先移走或删除分组内素材',
  'errorDoc.invalid_parameter.scene': '参数不合法或组合不受支持（不会静默丢弃）',
  'errorDoc.invalid_parameter.action': '对照能力表修正参数',
  'errorDoc.asset_not_ready.scene': '素材仍在处理中',
  'errorDoc.asset_not_ready.action': '等待状态变为 available 后重试',
  'errorDoc.authorization_required.scene': '真人素材缺少有效授权',
  'errorDoc.authorization_required.action': '完成真人授权后重试',
  'errorDoc.rate_limited.scene': '超出 Key 的 RPM，或账号 / Key 的并发上限',
  'errorDoc.rate_limited.action': '按 Retry-After 退避后重试',
  'errorDoc.internal_error.scene': '平台内部错误',
  'errorDoc.internal_error.action': '带同一幂等键重试',
  'errorDoc.no_available_channel.scene': '暂时没有可用的处理线路（作为任务失败码出现）',
  'errorDoc.no_available_channel.action': '稍后用新的幂等键重新提交',
};

export default messages;
